import gql from "graphql-tag";

// fragment
export const POT_SIZE_FRAGMENT = gql`
    fragment potSize on PotSizeNode {
        id
        potSizeCm
        updatedAt
        updatedBy
    }
`;

// all query
export const POT_SIZES_QUERY = gql`
    query {
        tenantPotSizes {
            edges {
                node {
                    ...potSize
                }
            }
        }
    }
    ${POT_SIZE_FRAGMENT}
`;

// single query
export const SINGLE_POT_SIZE_QUERY = gql`
    query potSize($id: ID!) {
        potSize(id: $id) {
            ...potSize
        }
    }
    ${POT_SIZE_FRAGMENT}
`;

// create
export const CREATE_POT_SIZE_MUTATION = gql`
    mutation createPotSize($input: CreatePotSizeInput!) {
        createPotSize(input: $input) {
            potSize {
                ...potSize
            }
        }
    }
    ${POT_SIZE_FRAGMENT}
`;

// update
export const UPDATE_POT_SIZE_MUTATION = gql`
    mutation updatePotSize($input: UpdatePotSizeInput!) {
        updatePotSize(input: $input) {
            potSize {
                ...potSize
            }
        }
    }
    ${POT_SIZE_FRAGMENT}
`;

// delete
export const DELETE_POT_SIZE_MUTATION = gql`
    mutation deletePotSize($input: DeletePotSizeInput!) {
        deletePotSize(input: $input) {
            potSize {
                ...potSize
            }
        }
    }
    ${POT_SIZE_FRAGMENT}
`;
